import React from 'react';
import PropTypes from 'prop-types';
import store from 'store';
import actions from 'store/actions';
import APIService from 'services/cloudApi.js';
import Launcher from 'components/launcher';
import Viewer from 'components/viewer';
import NoticeModal from 'components/noticeModal'
import { SynchronizeController } from 'services/3dviewer/moving-controls/synchronizeController';

import queryString from 'query-string';
import 'bootstrap/dist/css/bootstrap.min.css';
import './main.scss';

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldViewerShow: false,
      shouldErrorShow: false,
      isDataReady: false,
      isViewerReady: false,
      isMultiFloor: false,
      showWarningModal: false,
    };

    this.cache = null;
  }

  async componentDidMount () {
    this.checkData();
    this.getQueryStringList();
    const { buildingId } = this.props;

    // 取得該物件房仲客戶的浮水印 , logo , 是否需要警語 modal
    try {
      const { logoUrl, watermarkUrl, isWarning } = await APIService.fetchCustomerData(
        buildingId
      );
      this.toggleWarngingModal(!!isWarning)
      store.dispatch(actions.setCustomerLogo({ logoUrl, watermarkUrl }));
    } catch (error) {
      console.log(error);
    }
  }

  async checkData () {
    const { buildingId } = this.props;

    //TODO: do we need this ?
    const data = await APIService.fetchMultifloorBuilding(buildingId);

    if (data) {
      let multifloorId = data.floors.data.map(data => data.ID);

      let showError = false;
      for (let i = 0; i < multifloorId.length; i++) {
        let floorId = multifloorId[i];
        const floorPanos = await APIService.fetchPanoramas(floorId);

        if (!floorPanos) {
          showError = true;
          break;
        }
      }

      if (!showError) {
        this.setState({ shouldViewerShow: true });
      } else {
        this.setState({ shouldErrorShow: true });
      }
    } else {
      const buildingPanos = await APIService.fetchPanoramas(buildingId);
      if (buildingPanos) {
        this.setState({ shouldViewerShow: true });
      } else {
        this.setState({ shouldErrorShow: true });
      }
    }
  }

  getQueryStringList = () => {
    // deal with query string
    const parsedStrs = queryString.parse(window.location.search);
    store.dispatch(actions.setQueryStringList(parsedStrs));
  };

  dataLoadingFinish = (isMultiFloor) => {
    this.setState({ isDataReady: true, isMultiFloor: isMultiFloor });
  };

  viewerLoadingFinish = () => {
    this.setState({ isViewerReady: true });
    this.cache = null;

    this.viewer.leftScene.canvas.addEventListener(
      'webglcontextlost',
      this.handleContextLost,
      false
    );
    this.viewer.leftScene.canvas.addEventListener(
      'webglcontextrestored',
      this.handleContextRestore,
      false
    );
  };

  handleContextLost = e => {
    this.setState(
      {
        isDataReady: false,
      },
      () => {
        // reset viewaer
        store.dispatch(actions.setViewButton(null));

        if (!this.cache) this.cache = SynchronizeController.cache();
        SynchronizeController.reset();

        // reopen viewer with new key
        this.setState({ isDataReady: true });
      }
    );
  };

  handleContextRestore = e => {
    console.log(e);
  };

  toggleWarngingModal = (value) => {
    this.setState({ showWarningModal: value })
  }

  render () {
    const { buildingId } = this.props;
    const {
      shouldErrorShow,
      shouldViewerShow,
      isDataReady,
      isViewerReady,
      showWarningModal
    } = this.state;

    return (
      <>
        {shouldErrorShow && <div className="errorLog">Building Not Found.</div>}
        {(shouldViewerShow && !isDataReady && !isViewerReady) && (
          <Launcher buildingId={buildingId} onReady={this.dataLoadingFinish} />
        )}
        <NoticeModal show={showWarningModal} toggleWarngingModal={this.toggleWarngingModal} />
        {shouldViewerShow && isDataReady && (
          <Viewer
            isMultiFloor={this.state.isMultiFloor}
            ref={ref => (this.viewer = ref)}
            changeFloor={this.changeFloor}
            onReady={this.viewerLoadingFinish}
            cache={this.cache}
          />
        )}
      </>
    );
  }
}

Main.propTypes = {
  buildingId: PropTypes.string.isRequired,
};
